import qs from 'qs'
import { HTTPv2, Service } from '@/services/config'
import { removePropertyEmpty } from '@/utils/index'
import {
  IFinalizeInspectionParams,
  IInspectionChecklistPostParams,
  IInspectionChecklistPutParams
} from '@/types/inspection.types'

class InspectionServiceV2 extends Service {
  path = 'vistoria'

  constructor() {
    super(HTTPv2)
  }

  async get(params: any) {
    const httpResponse = await this.httpClient.get(this.path, {
      params: removePropertyEmpty(params),
      paramsSerializer: (params) => {
        return qs.stringify(params)
      }
    })
    return httpResponse
  }

  async getById(id: any) {
    const httpResponse = await this.httpClient.get(`${this.path}/${id}`)
    return httpResponse
  }

  async post(params: any) {
    const httpResponse = await this.httpClient.post(this.path, params)
    return httpResponse
  }

  async postBatch(params: any) {
    const httpResponse = await this.httpClient.post(
      `${this.path}/vistorialote`,
      params
    )
    return httpResponse
  }

  async put(id: string, params: any) {
    const httpResponse = await this.httpClient.put(
      `/${this.path}?vistoriaId=${id}`,
      params
    )
    return httpResponse
  }

  async postFrota(params: any) {
    const httpResponse = await this.httpClient.post(
      `/${this.path}/frota`,
      params
    )
    return httpResponse
  }

  async iniciar(id: string) {
    const httpResponse = await this.httpClient.put(
      `/${this.path}/iniciar/${id}`
    )
    return httpResponse
  }

  async putRealizar(id: string, params: any) {
    const httpResponse = await this.httpClient.put(
      `/${this.path}/editar-fluxo-realizar/?vistoriaId=${id}`,
      params
    )
    return httpResponse
  }

  async clone(params: any) {
    const httpResponse = await this.httpClient.put(
      `/${this.path}/clonar`,
      {},
      {
        params: removePropertyEmpty(params),
        paramsSerializer: (params) => qs.stringify(params)
      }
    )
    return httpResponse
  }

  async finalize(params: IFinalizeInspectionParams) {
    const httpResponse = await this.httpClient.post(
      `/${this.path}/finalizar-vistoria`,
      params
    )
    return httpResponse
  }

  async finalizeEvaluation(params: IFinalizeInspectionParams) {
    const httpResponse = await this.httpClient.post(
      `/${this.path}/finalizarAvaliacao`,
      params
    )
    return httpResponse
  }

  async getSignature(id: string) {
    const httpResponse = await this.httpClient.get(
      `/${this.path}/obterassinaturas?vistoriaId=${id}`
    )
    return httpResponse
  }

  async postChecklist(params: IInspectionChecklistPostParams) {
    const httpResponse = await this.httpClient.post(
      `/${this.path}/checklist`,
      params
    )
    return httpResponse
  }

  async updateChecklistStatus(params: IInspectionChecklistPutParams) {
    const httpResponse = await this.httpClient.put(
      `/${this.path}/aprovar-reprovar-checklist`,
      params
    )
    return httpResponse
  }

  async getHistoryCR(id: string) {
    const httpResponse = await this.httpClient.get(
      `/${this.path}/${id}/historico-cr`
    )
    return httpResponse
  }
}

export const inspectionServiceV2 = new InspectionServiceV2()
